module.exports = __webpack_public_path__ + "static/media/amy-humphries-R_a3-W5ODvA-unsplash(1).31cc976f.jpg";